module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile ? true : false) ? _c('div', {
    staticClass: "profile-container-new",
    attrs: {
      "id": "profile-container-new"
    },
    on: {
      "scroll": _vm.getScrollPos
    }
  }, [_c('div', {
    staticClass: "overlay-container"
  }, [_c('i', {
    staticClass: "material-icons white--text pointer",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v(" "), _c('div', {
    staticClass: "more-vert-icon"
  }, [_c('div', {
    staticClass: "dropdown-container",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focusout": function($event) {
        _vm.showMoreOptionDialog = false
      }
    }
  }, [(_vm.profile.uid === _vm.user.uid) ? _c('i', {
    staticClass: "material-icons white--text pointer",
    on: {
      "click": function($event) {
        _vm.showMoreOptionDialog = !_vm.showMoreOptionDialog
      }
    }
  }, [_vm._v("more_vert")]) : _vm._e(), _vm._v(" "), (_vm.showMoreOptionDialog) ? _c('div', {
    staticClass: "dropdown-card-container"
  }, [_c('div', {
    staticClass: "logout-text",
    on: {
      "click": function($event) {
        _vm.logout();
        _vm.$router.push('/?loc=Worldwide')
      }
    }
  }, [_vm._v("Logout")])]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.cover === null || _vm.checkVideo(_vm.profile.cover)) ? _c('img', {
    staticClass: "profile-cover-image",
    attrs: {
      "src": _vm.profileFallBackImage()
    }
  }) : _c('img', {
    staticClass: "profile-cover-image",
    attrs: {
      "src": _vm.listviewImage(_vm.profile.cover, _vm.profile)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-details-desktop"
  }, [(_vm.profile.dp !== null) ? _c('img', {
    staticClass: "profile-image",
    style: (_vm.profile.uid === _vm.user.uid ? 'cursor:pointer' : ''),
    attrs: {
      "src": _vm.profile.dp
    },
    on: {
      "click": function($event) {
        _vm.profile.uid === _vm.user.uid ? _vm.createModelObj() : ''
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "other-details"
  }, [(_vm.profile.uid === _vm.user.uid) ? _c('button', {
    staticClass: "upload-image-button",
    on: {
      "click": _vm.goToUpload
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("photo_camera")]), _vm._v(" Submit a photo/video\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name-uploader-links"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.cropUsername(_vm.profile.name)))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "social-links"
  }, [(_vm.profile.social ? _vm.profile.social.instagram != '' : false) ? _c('img', {
    attrs: {
      "height": "18px",
      "src": require("../../static/img/insta_BandW.svg")
    },
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.profile.social.instagram)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.social ? _vm.profile.social.facebook != '' : false) ? _c('img', {
    attrs: {
      "height": "18px",
      "src": require("../../static/img/fb_Band W.svg")
    },
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.profile.social.facebook)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.social ? _vm.profile.social.twitter != '' && _vm.profile.social.twitter != undefined : false) ? _c('img', {
    attrs: {
      "height": "18px",
      "src": require("../../static/img/twitter_BandW.svg")
    },
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.profile.social.twitter)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.profile.uid === _vm.user.uid) ? _c('button', {
    staticClass: "edit-profile-button",
    on: {
      "click": function($event) {
        _vm.profileEditDialog = true;
        _vm.createModelObj()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons white--text"
  }, [_vm._v("edit")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bio"
  }, [_vm._v(_vm._s(_vm.profile.desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "uploader-details-mobile"
  }, [(_vm.profile.uid === _vm.user.uid) ? _c('button', {
    staticClass: "upload-image-button",
    on: {
      "click": _vm.goToUpload
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("photo_camera")]), _vm._v(" Submit a photo/video\n    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.dp !== null) ? _c('img', {
    staticClass: "profile-image",
    style: (_vm.profile.uid === _vm.user.uid ? 'cursor:pointer' : ''),
    attrs: {
      "src": _vm.profile.dp
    },
    on: {
      "click": function($event) {
        _vm.profile.uid === _vm.user.uid ? _vm.createModelObj() : ''
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "other-details"
  }, [_c('div', {
    staticClass: "name-uploader-links"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.cropUsername(_vm.profile.name)))]), _vm._v(" "), (_vm.profile.social ? _vm.profile.social.instagram != '' || _vm.profile.social.facebook != '' || _vm.profile.social.facebook != '' : false) ? _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "social-links"
  }, [(_vm.profile.social ? _vm.profile.social.instagram != '' : false) ? _c('img', {
    attrs: {
      "height": "18px",
      "src": require("../../static/img/insta_BandW.svg")
    },
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.profile.social.instagram)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.social ? _vm.profile.social.facebook != '' : false) ? _c('img', {
    attrs: {
      "height": "18px",
      "src": require("../../static/img/fb_Band W.svg")
    },
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.profile.social.facebook)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.social ? _vm.profile.social.twitter != '' && _vm.profile.social.twitter != undefined : false) ? _c('img', {
    attrs: {
      "height": "18px",
      "src": require("../../static/img/twitter_BandW.svg")
    },
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.profile.social.twitter)
      }
    }
  }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bio"
  }, [_vm._v(_vm._s(_vm.profile.desc))])]), _vm._v(" "), (_vm.profile.uid === _vm.user.uid) ? _c('button', {
    staticClass: "edit-profile-button-mobile",
    on: {
      "click": function($event) {
        _vm.profileEditDialog = true;
        _vm.createModelObj()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons white--text"
  }, [_vm._v("edit")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uploader-counts-and-tab"
  }, [_c('div', {
    staticClass: "uploader-tabs"
  }, [_c('div', {
    staticClass: "tab-section",
    style: (_vm.selectedCount == 'shared' ? 'color: #f5a623;font-weight: 800;box-shadow: 0 -1px 7px 0 #000000;background-color: #000000;' : ''),
    on: {
      "click": function($event) {
        _vm.selectedCount = 'shared', _vm.$router.replace(("/profile?selected_tab=shared&profile_id=" + (_vm.$route.query.profile_id)));
        _vm.getLocation()
      }
    }
  }, [_c('div', {
    staticClass: "tab pointer"
  }, [_vm._v("SUBMITTED")]), _vm._v(" "), _c('div', {
    staticClass: "tab-count"
  }, [_vm._v(_vm._s(_vm.profile.shared))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-section",
    style: (_vm.selectedCount == 'checkins' ? 'color: #f5a623;font-weight: 800;box-shadow: 0 -1px 7px 0 #000000;background-color: #000000;' : ''),
    on: {
      "click": function($event) {
        _vm.selectedCount = 'checkins', _vm.$router.replace(("/profile?selected_tab=checkins&profile_id=" + (_vm.$route.query.profile_id)));
        _vm.getLocation()
      }
    }
  }, [_c('div', {
    staticClass: "tab pointer"
  }, [_vm._v("TRAVEL LIST")]), _vm._v(" "), _c('div', {
    staticClass: "tab-count"
  }, [_vm._v(_vm._s(_vm.profile.checkins))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-section",
    style: (_vm.selectedCount == 'likes' ? 'color: #f5a623;font-weight: 800;box-shadow: 0 -1px 7px 0 #000000;background-color: #000000;' : ''),
    on: {
      "click": function($event) {
        _vm.selectedCount = 'likes', _vm.$router.replace(("/profile?selected_tab=likes&profile_id=" + (_vm.$route.query.profile_id)));
        _vm.getLocation()
      }
    }
  }, [_c('div', {
    staticClass: "tab pointer"
  }, [_vm._v("LIKED")]), _vm._v(" "), _c('div', {
    staticClass: "tab-count"
  }, [_vm._v(_vm._s(_vm.profile.likes))])])])]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [(_vm.$store.state.userProfile.profileImages.length != 0) ? _c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding-bottom": "8em"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.$store.state.userProfile.profileImages), function(img, imgIndex) {
    return _c('v-flex', {
      key: imgIndex,
      attrs: {
        "xs6": "",
        "sm4": "",
        "md2": ""
      }
    }, [(img.resourceType == 'image') ? _c('div', {
      staticClass: "img-height",
      on: {
        "click": function($event) {
          return _vm.$router.push(("/id/" + (img.id) + "?inapp=true"))
        }
      }
    }, [_c('v-lazy-image', {
      attrs: {
        "src": _vm.mapViewImage(img.id, img)
      }
    })], 1) : _c('div', {
      staticClass: "img-height",
      on: {
        "click": function($event) {
          return _vm.$router.push(("/id/" + (img.id) + "?inapp=true"))
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "56.25% 0 0 0",
        "position": "relative"
      }
    }, [_c('iframe', {
      staticStyle: {
        "position": "absolute",
        "top": "0",
        "left": "0",
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": _vm.getVideoEmbedLink(img.id),
        "frameborder": "0",
        "allow": "autoplay; fullscreen",
        "allowfullscreen": ""
      }
    })])])])
  }), 1)], 1) : _c('div', {
    staticClass: "bottom-space"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-footer-bottom",
    attrs: {
      "id": "user-footer"
    }
  }, [_c('div', {
    staticClass: "footer-icons option-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.goToHome()
      }
    }
  }, [_c('img', {
    staticClass: "wav-icon-footer",
    attrs: {
      "height": "12",
      "src": require("../../static/img/wav-icon.png")
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goToHome()
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-icons option-container"
  }, [_c('button', {
    on: {
      "click": _vm.goToUpload
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("photo_camera")])]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.goToUpload
    }
  }, [_vm._v("Add Photo")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-icons option-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/'
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("reorder")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.clickedMode('list');
        _vm.$store.state.common.swichModesBG = false
      }
    }
  }, [_vm._v("List view")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-icons option-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/filter',
          query: _vm.$route.query
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/filter',
          query: _vm.$route.query
        })
      }
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-icons user_account option-container"
  }, [_c('button', {
    style: (_vm.isLoggedIn ? 'opacity: 1' : ''),
    on: {
      "click": function($event) {
        _vm.refreshPage();
        _vm.isLoggedIn ? _vm.$router.push({
          path: '/profile',
          query: {
            uploader: 'user',
            profile_Id: _vm.user.uid,
            selected_tab: 'checkins'
          }
        }) : _vm.$router.push("/login")
      }
    }
  }, [(!_vm.isLoggedIn && _vm.screenW < 768) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn && _vm.screenW > 768) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("perm_identity")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('img', {
    staticStyle: {
      "height": "1.75rem",
      "width": "1.75rem",
      "border-radius": "100%"
    },
    attrs: {
      "src": _vm.user.photoURL,
      "alt": "profile photo"
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.refreshPage();
        _vm.isLoggedIn ? _vm.$router.push({
          path: '/profile',
          query: {
            profile_Id: _vm.user.uid,
            selected_tab: 'checkins'
          }
        }) : _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Me")])])]), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.profileEditDialog),
      callback: function($$v) {
        _vm.profileEditDialog = $$v
      },
      expression: "profileEditDialog"
    }
  }, [_c('v-card', [(_vm.profileEditDialog) ? _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.editProfile.name),
      callback: function($$v) {
        _vm.$set(_vm.editProfile, "name", $$v)
      },
      expression: "editProfile.name"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "upload-profile-photo"
    }
  }, [(_vm.editProfile.dp != '') ? _c('img', {
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "height": "200px",
      "width": "100%",
      "src": _vm.editProfile.dp
    },
    on: {
      "click": _vm.openCloudinaryProfileImageWidget
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "profileImageUpload",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "id": "upload-profile"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1.4em",
      "color": "#999999",
      "margin-right": "10px"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticClass: "pointer",
    on: {
      "click": _vm.openCloudinaryProfileImageWidget
    }
  }, [_vm._v("\n            Upload Profile Photo\n          ")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Facebook"
    },
    model: {
      value: (_vm.editProfile.social.facebook),
      callback: function($$v) {
        _vm.$set(_vm.editProfile.social, "facebook", $$v)
      },
      expression: "editProfile.social.facebook"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Instagram"
    },
    model: {
      value: (_vm.editProfile.social.instagram),
      callback: function($$v) {
        _vm.$set(_vm.editProfile.social, "instagram", $$v)
      },
      expression: "editProfile.social.instagram"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Twitter"
    },
    model: {
      value: (_vm.editProfile.social.twitter),
      callback: function($$v) {
        _vm.$set(_vm.editProfile.social, "twitter", $$v)
      },
      expression: "editProfile.social.twitter"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Description"
    },
    model: {
      value: (_vm.editProfile.desc),
      callback: function($$v) {
        _vm.$set(_vm.editProfile, "desc", $$v)
      },
      expression: "editProfile.desc"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "grey blue--text",
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue blue--text",
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": _vm.saveEditedProfileChanges
    }
  }, [_vm._v("Confirm Changes")])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2123f07c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile.vue
// module id = 835
// module chunks = 2